import { authClient } from "../lib/auth-client"
import { useAuth } from "./useAuth"

/**
 * Whether the current user holds an ADMINISTRATIVE role over the active
 * workspace — a platform super-admin (`user.isAdmin`), or the active
 * organization's `owner` / `admin`.
 *
 * The per-org role is NOT in the Better Auth session (that only carries the
 * global `role === "admin"` flag) — it lives in the organization plugin's
 * `member` table, read here via `useActiveMember()`. This mirrors the backend's
 * `isOrgOwnerOrAdmin` (backend/src/db/membership.ts), so a UI gated on this hook
 * matches what the API will actually allow.
 *
 * Use it for destructive/administrative affordances (permanent delete, audit
 * access, settings writes). A plain member — even one who organized the meeting
 * — is not an org admin.
 */
export function useIsOrgAdmin(): boolean {
  const { user } = useAuth()
  const { data: activeMember } = authClient.useActiveMember()
  const orgRole = (activeMember as { role?: string } | null | undefined)?.role
  return !!user?.isAdmin || orgRole === "owner" || orgRole === "admin"
}
